export default __webpack_public_path__ + "static/img/tap.9789b9b.svg";